import { useLanguage } from './useLanguage';
import { ArrowLeft, ArrowRight, ChevronLeft, ChevronRight } from 'lucide-react';
import { LucideIcon } from 'lucide-react';

type Direction = 'left' | 'right';

/**
 * Hook to get RTL-aware direction
 * In RTL (Arabic), left becomes right and right becomes left
 */
export const useRTLDirection = () => {
  const { isRTL } = useLanguage();

  const getDirection = (direction: Direction): Direction => {
    if (!isRTL) return direction;
    return direction === 'left' ? 'right' : 'left';
  };

  return { getDirection, isRTL };
};

/**
 * Hook to get RTL-aware arrow icons
 * In RTL (Arabic), ArrowLeft becomes ArrowRight and vice versa
 */
export const useRTLArrow = () => {
  const { isRTL } = useLanguage();

  const getArrow = (direction: 'left' | 'right'): LucideIcon => {
    if (!isRTL) {
      return direction === 'left' ? ArrowLeft : ArrowRight;
    }
    // In RTL, flip the arrows
    return direction === 'left' ? ArrowRight : ArrowLeft;
  };

  const getChevron = (direction: 'left' | 'right'): LucideIcon => {
    if (!isRTL) {
      return direction === 'left' ? ChevronLeft : ChevronRight;
    }
    // In RTL, flip the chevrons
    return direction === 'left' ? ChevronRight : ChevronLeft;
  };

  return { getArrow, getChevron, isRTL };
};


